module.exports = __webpack_public_path__ + "img/2-1.6bd964c4.jpg";